import {
  keepPreviousData,
  queryOptions,
  useQuery,
} from '@tanstack/react-query';

import { baseAPI } from '~shared/api/base-api';
import { KEYS } from '~shared/api/query-keys';

import type { GetGroupsResponse } from '../modal/group';

export interface GetGroupsParams {
  page?: number;
  limit?: number;
  search?: string;
}

export const getGroupsAPI = async (params?: GetGroupsParams) => {
  const response = await baseAPI.get<GetGroupsResponse>(
    `custom-form/studio/fields`,
    {
      params: {
        ...params,
        type: 'group',
      },
    },
  );
  return response.data;
};

export const getGroupsQueryOptions = (params?: GetGroupsParams) =>
  queryOptions({
    queryKey: [KEYS.GROUPS, params],
    queryFn: () => getGroupsAPI(params),
    placeholderData: keepPreviousData,
  });

export const useGetGroups = (params?: GetGroupsParams) => {
  return useQuery(getGroupsQueryOptions(params));
};
